import React from 'react';
import type { ComponentPropsWithoutRef, CSSProperties } from 'react';

import PropTypes from 'prop-types';

import clsx from 'clsx';

import styles from './Icon.module.css';

export type IconColor = 'primary' | 'secondary' | 'secondary_emphasized' | 'lightGray' | 'superLightGray' | 'error' | 'white' | 'white_base';

export type IconSize = '16px' | '20px' | '24px' | '32px' | '48px' | '56px' | '64px' | '80px' | '96px' | '100%';
export type IconRightIndent = '4px' | '8px' | '12px' | '16px' | '24px' | '32px';
export type IconLeftIndent = '2px' | '4px' | '8px' | '12px' | '16px' | '24px' | '32px';

const colorClass: Record<IconColor, string> = {
    primary: styles.primary,
    secondary: styles.secondary,
    secondary_emphasized: styles.secondaryEmphasized,
    lightGray: styles.lightGray,
    superLightGray: styles.superLightGray,
    error: styles.error,
    white: styles.white,
    white_base: styles.whiteBase,
};

export interface IconProps {
    name: string;
    size?: IconSize;
    rightIndent?: IconRightIndent;
    leftIndent?: IconLeftIndent;
    color?: IconColor;
}

export const Icon = ({ rightIndent, leftIndent, color, size, name }: IconProps) => {
    const style = { '--icon-size': size, marginRight: rightIndent, marginLeft: leftIndent } as CSSProperties;

    return (
        <span className={clsx(styles.icon, color && colorClass[color])} style={style}>
            <svg>
                <use xlinkHref={`/i/svg-icons/icons.svg#${name}`} />
            </svg>
        </span>
    );
};

type IconPropTypes = ComponentPropsWithoutRef<typeof Icon>;

Icon.propTypes = {
    name: PropTypes.string.isRequired,
    color: PropTypes.oneOf(['primary', 'secondary', 'secondary_emphasized', 'lightGray', 'superLightGray', 'error', 'white', 'white_base']),
    size: PropTypes.oneOf(['16px', '20px', '24px', '32px', '48px', '56px', '64px', '80px', '96px', '100%']),
    rightIndent: PropTypes.oneOf(['4px', '8px', '12px', '16px', '24px', '32px']),
    leftIndent: PropTypes.oneOf(['2px', '4px', '8px', '12px', '16px', '24px', '32px']),
} as PropTypes.ValidationMap<IconPropTypes>;
